import { Box, Button, LayoutContent, LayoutContentBody, LayoutContentCenter, LayoutContentHeader, LayoutControls, Typography, } from '@pinwheel/origami';
import React, { useMemo } from 'react';
import { TextListItems } from '../LinkApiRouter/components/TextListItems';
import { ScreenTitleHeader } from './ScreenTitleHeader';
var EmptyComponent = function () { return React.createElement(React.Fragment, null); };
/**
 * This component is used to show a screen where there will be a an
 * image, title, subtitle, and continue button.
 */
export function TemplateContinue(props) {
    var _a = props.Image, Image = _a === void 0 ? EmptyComponent : _a, title = props.title, subtitle = props.subtitle, _b = props.subtitleVariant, subtitleVariant = _b === void 0 ? 'body' : _b, _c = props.textList, textList = _c === void 0 ? [] : _c, _d = props.dataTestId, dataTestId = _d === void 0 ? 'TemplateContinue' : _d, extraControls = props.extraControls, _e = props._disableScreenTitleHeaderComponent, _disableScreenTitleHeaderComponent = _e === void 0 ? false : _e;
    var titleText = typeof title === 'string' ? title : title.plaintext;
    var subtitleText = typeof subtitle === 'string' ? subtitle : subtitle === null || subtitle === void 0 ? void 0 : subtitle.plaintext;
    var actions = useMemo(function () {
        if ('actions' in props)
            return props.actions;
        return (React.createElement(Button, { eventId: props.buttonEventId, dataTestId: "button", onClick: function () { return props.onContinue(); }, "aria-label": props.buttonLabel }, props.buttonLabel));
    }, [props]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContent, { "data-testid": dataTestId },
            React.createElement(LayoutContentCenter, null,
                React.createElement(LayoutContentHeader, null,
                    React.createElement(Image, null)),
                React.createElement(LayoutContentBody, null,
                    _disableScreenTitleHeaderComponent ? (React.createElement(Box, null,
                        React.createElement(Typography, { as: "h2", variant: "header", color: "title", weight: "bold", align: "center" }, titleText))) : (React.createElement(ScreenTitleHeader, { variant: "header", color: "title", as: "h2", align: "center", weight: "bold" }, titleText)),
                    React.createElement(Typography, { variant: subtitleVariant, color: "default", weight: "normal", align: "center" }, subtitleText),
                    textList ? (React.createElement("ul", { "data-testid": "templateContinue__list", className: "templateContinue__list", style: {
                            textAlign: 'left',
                        } },
                        React.createElement(TextListItems, { textList: textList }))) : null))),
        React.createElement(LayoutControls, null,
            extraControls,
            actions)));
}
